import type { FaireProductEntity } from "../../entity_types/product";

export const p_aadnqwxg3g: FaireProductEntity = {
  token: "p_aadnqwxg3g",
  type: "product",
  name: "Her Glow Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/4b2d55389920e47973b01d052fdc2dcb0f2aee6f470e966cce9859687755fa48.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0cd0b599b3f0304e9a33d3e5ee4ef292fcbdde524421d76252ce2f036a7cec52.jpeg",
    "https://cdn.faire.com/fastly/7d460ce0e7d4eb1dd986fd2874251606e0fdb9dc70cb33a3227959e55eec8a86.jpeg",
    "https://cdn.faire.com/fastly/72bd2be1a6df602adcd6b3d6c45a4ba19b7b2972447a86c2b38dcc9361d9bc71.jpeg",
    "https://cdn.faire.com/fastly/8e2a0fa910c2b798e6a976e22d714561252e31bf3ba87ad719c18e30520c634a.jpeg",
    "https://cdn.faire.com/fastly/c3d429aaae2e376e7d70e17df65cb2bd042adc02674495b4ec1adc03c745ef64.jpeg",
    "https://cdn.faire.com/fastly/0c0a1f696c1b4ff548316a2e50e10cdfa15e8c3b98c6f744f8685d34f523df23.jpeg",
    "https://cdn.faire.com/fastly/6c5a2f34122275adefe8ddb95d94aced054eb0bdf90e1dda874eda8300c56b76.jpeg",
    "https://cdn.faire.com/fastly/0f7d7b94c3eb5b144738130fe40cb80ba556d1ea531029b1fb28bf9c2b16cb6e.jpeg",
    "https://cdn.faire.com/fastly/70897898d0cacf5632f0eab64d77f22a8bac16c3093377565ae46abf3bdc3782.jpeg",
  ],
  priceDollars: 7,
  description:
    "Why We Made This?\n\nA playful evolution of our Her and Her Lurex. Featuring a soft, solid base with a shimmering contrast heel and toe, Her Glow offers the best of both worlds. Designed with a playful, glittery finish that’s made to be seen and is the perfect companion for mules, slingbacks, or a sparkly peep through open-toed sandals.\n\nContents: \n\n79% Modal, 18% Polyester, 2% Spandex, 1% Lurex\n\n\n\n\nSizing:\n\nOne size fits most (US women's size 6-10)\n\n\n\n\nCare Instructions:\n\nMachine wash cold\n\nTumble dry low\n\nDo not iron\n\nDo not bleach\n\n\n\n***Order in units of 6 (6,12,18,24 etc)\n\n\n\nMSRP: $14 USD\n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:06.451Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
